import React from "react";
import { CoverClubPage } from "@/components/coverClub";

export default function CoverClub() {
  return <CoverClubPage />;
}
